<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect x="5" y="5" width="25" height="25" rx="2"/><rect x="34" y="5" width="25" height="25" rx="2"/><rect x="5" y="34" width="25" height="25" rx="2"/><rect x="34" y="34" width="25" height="25" rx="2"/></svg>